// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import App from './App'
import router from './router'
import 'swiper/js/swiper.min.js'
import 'swiper/css/swiper.min.css'
Vue.config.productionTip = false
Vue.prototype.$http = axios
// Vue.prototype.$http.defaults.baseURL = 'http://' + window.location.host
// Vue.prototype.$http.defaults.baseURL = 'https://58keeper.com'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js